






























import {Component, Prop, Vue} from 'vue-property-decorator';

import {IActiveShipment} from "@/models/StoreModels";
import { ShipmentLogic } from '@/models/ShipmentLogic';

@Component({
  name: 'CardButton',
  components: {
  },
})
export default class CardButton extends Vue {
  @Prop()
  private userId!: number;

  @Prop()
  private shipment!: IActiveShipment;

  private get userIsRecipientAndHasToDropoff() {
    return ShipmentLogic.userIsSender(this.shipment, this.userId) && ShipmentLogic.isAwaitingDropoff(this.shipment);
  }

  private get userCanCancelOrder(): boolean {
    return this.userIsRecipientAndHasToDropoff;
  }

  private get userNeedsToSelectHub() {
    return ShipmentLogic.userIsRecipient(this.shipment, this.userId) && ShipmentLogic.needsDestination(this.shipment);
  }

  private get userCanOpenLocker(): boolean {
    return ShipmentLogic.userIsRecipient(this.shipment, this.userId) && ShipmentLogic.isAwaitingPickup(this.shipment)
        || this.userIsRecipientAndHasToDropoff;
  }
}
